import {inject, InjectionToken, Pipe, PipeTransform} from '@angular/core';

// Accepted types
export type SdLevel = 'SD3-' | 'SD2-' | 'SD1-' | 'SD0' | 'SD1' | 'SD2' | 'SD3';

export const SD_LEVEL_LABELS = new InjectionToken<
    Partial<Record<SdLevel, string>>
>('SD_LEVEL_LABELS', {
    factory: () => ({
        'SD3-': 'Desnutrición crónica severa',
        'SD2-': 'Desnutrición crónica moderada',
        'SD1-': 'Normal',
        'SD0': 'Normal',
        'SD1': 'Normal',
        'SD2': 'Alto para la edad',
        'SD3': 'Muy alto para la edad',
    }),
});

@Pipe({
    name: 'heightMalnutritionLevel',
    pure: true,
})
export class HeightMalnutritionLevelPipe implements PipeTransform {
    private labels = inject(SD_LEVEL_LABELS);

    /**
     * @param value  Nível SD (ex.: 'SD2-')
     * @param fallback Texto opcional caso não exista rótulo (default: próprio value)
     */
    transform(value: SdLevel | string | null | undefined, fallback?: string): string {
        if (!value) {
            return fallback ?? 'No medido';
        }
        const v = value as SdLevel;
        return this.labels[v] ?? fallback ?? String(value);
    }
}
